import {StyleSheet} from 'react-native';

// Theme-aware styles factory (docs/DARK-MODE.md). Style-as-function entries
// are preserved — the factory returns them closed over the theme's colors.
const makeStyles = colors =>
  StyleSheet.create({
    container: animation => ({
      backgroundColor: colors.overlay,
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
      opacity: animation,
    }),
    logo: animation => ({
      width: 150,
      height: 100,
      resizeMode: 'contain',
      opacity: animation,
    }),
    helperText: {
      textAlign: 'center',
    },
    pressableStyle: {
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      zIndex: 100,
    },
  });

export default makeStyles;
